export const PageHeader = ({ eyebrow, title, subtitle, action }) => (
  <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8 fade-up">
    <div>
      {eyebrow && <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#C86D51]">{eyebrow}</p>}
      <h1 className="mt-1 text-4xl sm:text-5xl font-extrabold tracking-tight text-[#1B2A26]" data-testid="page-title">{title}</h1>
      {subtitle && <p className="mt-2 text-base md:text-lg text-[#5C6B66] max-w-2xl">{subtitle}</p>}
    </div>
    {action}
  </div>
);
